module.exports = __webpack_public_path__ + "media/assets/images/smart_working/4-1-9ca2229ab5e3376d1aba41ce40fdc78f.png";